import { fetchUser, selectMerchant } from "@redux";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { formatMessage, useNotify } from "@utils";
import { Button, Drawer, Radio, Skeleton, Tabs } from "antd";
import { t } from "i18next";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useFullScreen } from "src/Helpers/useFullscreen";
import styled from "styled-components";
import { eComClaimPointAPI } from "../../API/ecomClaimpoint";
import { IconPoint } from "../icon/IconPoint";
import { BackIcon } from "../icon/TopSpender/BackIcon";
import { SharedInput } from "../shared";
const { TabPane } = Tabs;

export const ComponentSelectChannel = () => {
    const qrRef = useRef();
    const merchant = useSelector(selectMerchant);
    const { success, error, warning } = useNotify();
    const history = useHistory();
    const [tab, setTab] = useState<string>("1");
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const { themes } = useSelector(selectMerchant);
    const fullHeight = useFullScreen();
    const [open, setOpen] = useState(false);
    const [orderId, setOrderId] = useState<string>("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [showPopupConfirm, setShowPopupConfirm] = useState(false);
    const [channel, setChannel] = useState<string>("SHOPEE");
    const [point, setPoint] = useState<any>(0);
    const [displaySetting, setDisplaySetting] = useState<any>({});
    const [isExpanded, setIsExpanded] = useState(false);
    const [orderData, setOrderData] = useState<any>([]);
    const [isCheck, setIsCheck] = useState<boolean>(true);
    const [isLoading, setIsloading] = useState(false);
    const i18nextLng = window.localStorage.i18nextLng;
    const dispatch = useDispatch();

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const getDisplaySetting = async () => {
        try {
            const res = await eComClaimPointAPI.getDisplaySetting();
            if (res.data) {
                setDisplaySetting(res.data);
            }
        } catch (err: any) {
            error(formatMessage(err.response));
        }
    };

    const getOrder = async () => {
        // UIStore.setState({isLoading: true });
        try {
            const res = await eComClaimPointAPI.getOrder(channel);
            if (res.data) {
                setOrderData(res.data);
            }
            setIsloading(false);
            setIsCheck(false);
            UIStore.setState({ isLoading: false });
        } catch (err: any) {
            setIsCheck(false);
            UIStore.setState({ isLoading: false });
            error(formatMessage(err.response));
        }
    };
    useEffect(() => {
        UIStore.setState({ isLoading: false });
        getDisplaySetting();
    }, []);
    useEffect(() => {
        UIStore.setState({ isLoading: false });
        getOrder();
    }, [channel]);
    function cleanOrderId(input: string) {
        // eslint-disable-next-line no-control-regex, no-misleading-character-class
        const INVISIBLE_REGEX = /[\u200B\u0000-\u001F\u007F\u00A0\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180F\u2000-\u200F\u2028-\u202F\u205F\u2060-\u206F\uFEFF\uFFF0-\uFFFF]/g;
        return input.replace(INVISIBLE_REGEX, "").trim();
    }

    const sendOrder = async (orderIdData: string, channelData: string) => {
        if (orderIdData) {
            const orderId = await cleanOrderId(orderIdData);
            // console.log("orderId ==>", orderId.length);
            // console.log("orderIdData ==>", orderIdData.length);
            try {
                const res = await eComClaimPointAPI.claimPoint({
                    orderId: orderId,
                    storeType: channelData,
                });
                if (res.data) {
                    success(t("page.claimSuccess"));
                    setShowConfirm(true);
                    setPoint(res.data?.point);
                    UIStore.setState({ isLoading: false });
                    getOrder();
                    dispatch(fetchUser());
                }
            } catch (err: any) {
                if (
                    err.response &&
                    err.response.status === 400 &&
                    err.response.data?.message === "order not found"
                ) {
                    err.response?.data?.message
                        ? error(formatMessage(err.response))
                        : error(t("page.orderNotFound"));
                } else {
                    err.response?.data?.message
                        ? error(formatMessage(err.response))
                        : error(t("page.claimfalse"));
                    
                }
                UIStore.setState({ isLoading: false });
            }
        } else {
            warning(t("page.pleasEnterOrder"));
            UIStore.setState({ isLoading: false });
        }
    };

    const handleShowMore = () => {
        setIsExpanded(!isExpanded);
    };
    console.log("displaySetting", displaySetting);

    return (
        <StyledContainer color={themes?.themeColor!} style={{ height: fullHeight }}>
            <div className="container">
                <div className="backIcon" onClick={() => history.goBack()}>
                    <BackIcon color={themes?.themeColor!} />
                </div>
                <div className="header">
                    <Skeleton
                        active
                        // loading={true}
                        loading={isCheck}
                        title={true}
                        paragraph={false}
                    >
                        <img src={merchant?.themes?.logoSmallUrl} alt="" />
                    </Skeleton>
                </div>
                <StyledCollect
                    themeColor={
                        displaySetting?.backgroundForm?.isDefaultColor
                            ? themes?.themeColor
                            : displaySetting?.backgroundForm?.customFontColor
                    }
                >
                    <Skeleton
                        active
                        // loading={true}
                        loading={isCheck}
                        title={true}
                        paragraph={false}
                    >
                        <div className="wrapper-collect-main">
                            <div className="coin-01">
                                <img src="../../images/bg-ic-coin-01.svg" alt="" />
                            </div>
                            <div className="coin-02">
                                <img src="../../images/bg-ic-coin-02.svg" alt="" />
                            </div>
                            <div className="coin-03">
                                <img src="../../images/coin-03.svg" alt="" />
                            </div>

                            <div className="wrapper-collect">
                                <div className="layout-title-collect">
                                    <div className="title-collect">
                                        <span className="icon">
                                            <img src="../../images/ic-coin-collect.svg" alt="" />
                                        </span>
                                        <h2
                                            className="highlightTitle"
                                            style={{
                                                color: !displaySetting?.fontColorHighlightTitleSync
                                                    ?.isDefaultColor
                                                    ? displaySetting?.fontColorHighlightTitleSync
                                                          ?.customFontColor
                                                    : "#c6a12d",
                                            }}
                                        >
                                            {displaySetting?.[
                                                i18nextLng.includes("en") ? "en" : "th"
                                            ]?.highlightTitleSync || "Select platform"}
                                        </h2>
                                        <div className="rows-ic-collect">
                                            <span className="img">
                                                <img src="../../images/ic-shopee.svg" alt="" />
                                            </span>
                                            <span className="img">
                                                <img src="../../images/ic-lazada.svg" alt="" />
                                            </span>
                                            <span className="img">
                                                <img src="../../images/ic-tt.svg" alt="" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="content-collect">
                                    <h3
                                        style={{
                                            color: !displaySetting?.fontTitleDiscription
                                                ?.isDefaultColor
                                                ? displaySetting?.fontTitleDiscription
                                                      ?.customFontColor
                                                : "white",
                                        }}
                                    >
                                        {displaySetting?.[i18nextLng.includes("en") ? "en" : "th"]
                                            ?.title || "Collect points to redeem discounts"}
                                        <div className="coin-04">
                                            <img src="../../images/bg-ic-coin-04.svg" alt="" />
                                        </div>
                                    </h3>
                                    <p
                                        style={{
                                            color: !displaySetting?.fontTitleDiscription
                                                ?.isDefaultColor
                                                ? displaySetting?.fontTitleDiscription
                                                      ?.customFontColor
                                                : "white",
                                        }}
                                    >
                                        {displaySetting?.[i18nextLng.includes("en") ? "en" : "th"]
                                            ?.description || "Collect points to redeem discounts"}
                                    </p>
                                </div>
                                <div className="search-collect">
                                    <div className="group-collect">
                                        <div
                                            className="main-select-channel"
                                            style={{
                                                background:
                                                    channel === "SHOPEE"
                                                        ? "#F1592A"
                                                        : channel === "LAZADA"
                                                        ? "linear-gradient(180deg, #1A5BDC 17.86%, #112282 76.19%)"
                                                        : "#000",
                                            }}
                                            onClick={showDrawer}
                                        >
                                            <span>
                                                <img
                                                    src={
                                                        channel === "SHOPEE"
                                                            ? "../images/ic-shopee.svg"
                                                            : channel === "LAZADA"
                                                            ? "../images/ic-lazada.svg"
                                                            : "../images/ic-select.svg"
                                                    }
                                                    alt=""
                                                />
                                            </span>
                                            <img src="../images/Icon-dropdown.svg" alt="" />
                                        </div>
                                        <SharedInput
                                            placeholder={t("page.enterordernumberhere")}
                                            name="number"
                                            onChange={(e: any) => {
                                                let orderId = cleanOrderId(e.target.value);
                                                // let orderId = e.target.value;
                                                setOrderId(orderId);
                                            }}
                                            value={orderId}
                                            style={{ whiteSpace: "nowrap" }}
                                        />
                                        <Button
                                            className="btn-select-channel"
                                            icon={<img src="../../images/Icon-send.svg" alt="" />}
                                            onClick={() => {
                                                setShowPopupConfirm(true);
                                            }}
                                        ></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Skeleton>
                </StyledCollect>
                <StyledClaimOrder themeColor={themes?.themeColor!} isExpanded={isExpanded}>
                    <Skeleton
                        active
                        // loading={true}
                        loading={isCheck}
                        title={true}
                        paragraph={false}
                    >
                        <div className="wrapper-claimorder">
                            <div className="title-claim">{t("page.claimorderid")}</div>
                            <div className="layout-list-claim">
                                {orderData?.map((item: any, index: number) => (
                                    <div className="box-list-claim" key={index}>
                                        <div className="img-list-claim">
                                            <img
                                                src={
                                                    item.storeType === "LAZADA"
                                                        ? "../images/ic-lazada.svg"
                                                        : item.storeType === "SHOPEE"
                                                        ? "../images/ic-shopee.svg"
                                                        : "../images/ic-select.svg"
                                                }
                                                alt=""
                                            />
                                        </div>
                                        <div className="content-list-claim">
                                            <h2>Order {item.orderId || ""}</h2>
                                            <h3>
                                                {t("page.saleAmount")} : {item.price || 0}฿
                                            </h3>
                                        </div>
                                        <Button
                                            className="btn-list-claim"
                                            onClick={() => {
                                                setShowPopupConfirm(true);
                                                setOrderId(item.orderId);
                                            }}
                                        >
                                            {t("page.claim")}
                                            {/* {" "}
                                            <span style={{ color: "#26c2a4", paddingLeft: "5px" }}>
                                                <img src="../../images/ic-coin-point.svg" alt="" />{" "}
                                                + {item.pointToGet || 0}
                                            </span> */}
                                        </Button>
                                    </div>
                                ))}
                                {orderData?.length === 0 && (
                                    <div className="nodata">
                                        <span>
                                            <img src="../../images/nodata-platform.svg" alt="" />
                                        </span>
                                        {t("page.nodatafound")}
                                    </div>
                                )}
                                {/* <div className="box-list-claim">
                                    <div className="img-list-claim">
                                        <img src="../../images/ic-tt.svg" alt="" />
                                    </div>
                                    <div className="content-list-claim">
                                        <h2>Order #19376276913</h2>
                                        <h3>Sale Amount : 230฿</h3>
                                    </div>
                                    <div className="btn-list-claim" onClick={() => {
                                        setShowPopupConfirm(true);
                                        setOrderId("123123");
                                    }}>
                                        Claim{" "}
                                        <span>
                                            <img src="../../images/ic-coin-point.svg" alt="" /> + 5
                                        </span>
                                    </div>
                                </div> */}
                            </div>
                            {orderData?.length > 2 && (
                                <div className="showmore-list-claim">
                                    <div className="showmore-text-claim" onClick={handleShowMore}>
                                        Show more
                                    </div>
                                </div>
                            )}
                        </div>
                    </Skeleton>
                </StyledClaimOrder>
                <div className="banner-step-claim">
                    <Skeleton active loading={isCheck} title={true} paragraph={false}>
                        {displaySetting?.imageBanner?.length > 0 ? (
                            displaySetting.imageBanner.map((imageUrl: any, index: any) => (
                                <img key={index} src={imageUrl} alt={`Banner ${index + 1}`} />
                            ))
                        ) : (
                            <img src="../images/banner-step-1.png" alt="Default banner" />
                        )}
                    </Skeleton>
                </div>
                {/* <div className="title-big-step">
                    <span className="title-color">3 Steps</span>
                    <span className="sub-title-color">For Collect Point</span>
                </div>
                <div className="content-select-channel">
                    <div className="box-liststep">
                        <div className="img-box-liststep">
                            <EcomStepIcon color={themes?.themeColor!} />
                            <span>1</span>
                        </div>
                        <div className="text-box-liststep">Order frome-Commerce channels</div>
                    </div>
                    <div className="box-liststep">
                        <div className="img-box-liststep">
                            <EcomStepIcon color={themes?.themeColor!} />
                            <span>2</span>
                        </div>
                        <div className="text-box-liststep">Enter order number below</div>
                    </div>
                    <div className="box-liststep">
                        <div className="img-box-liststep">
                            <EcomStepIcon color={themes?.themeColor!} />
                            <span>3</span>
                        </div>
                        <div className="text-box-liststep">Collect points</div>
                    </div>
                    <div className="box-select-channel">
                        <div className="title-box-select">Select platform for sync Order</div>
                        <div className="main-select-channel" onClick={showDrawer}>
                            <span>
                                <img
                                    src={
                                        channel === "LAZADA"
                                            ? "../images/ic-lazada.svg"
                                            : channel === "SHOPEE"
                                            ? "../images/ic-shopee.svg"
                                            : "../images/ic-select.svg"
                                    }
                                    alt=""
                                />
                            </span>
                            {channel}
                        </div>
                        <div className="input-select-channel">
                            <SharedInput
                                placeholder="Enter order number here"
                                name="number"
                                onChange={(e: any) => setOrderId(e.target.value)}
                                value={orderId}
                            />
                        </div>
                        <div className="btn-select-channel">
                            <Button
                                className="check-order"
                                onClick={() => {
                                    sendOrder();
                                }}
                            >
                                Check order
                            </Button>
                        </div>
                    </div>
                </div> */}
                <Drawer
                    title="Select platform for sync Order"
                    onClose={onClose}
                    open={open}
                    placement="bottom"
                >
                    <div className="wrapper-drawer">
                        <Radio.Group
                            value={channel}
                            onChange={(e: any) => {
                                setChannel(e.target.value);
                            }}
                        >
                            <div className="layout-drawer">
                                <div className="content-drawer">
                                    <span>
                                        <img src="../images/ic-shopee.svg" alt="" />
                                    </span>
                                    Shopee
                                </div>
                                <div className="radio-drawer">
                                    <Radio value={"SHOPEE"}></Radio>
                                </div>
                            </div>
                            <div className="layout-drawer">
                                <div className="content-drawer">
                                    <span>
                                        <img src="../images/ic-lazada.svg" alt="" />
                                    </span>
                                    LAZADA
                                </div>
                                <div className="radio-drawer">
                                    <Radio value={"LAZADA"}></Radio>
                                </div>
                            </div>
                            <div className="layout-drawer">
                                <div className="content-drawer">
                                    <span>
                                        <img src="../images/ic-tt.svg" alt="" />
                                    </span>
                                    Tiktok Shop
                                </div>
                                <div className="radio-drawer">
                                    <Radio value={"TIKTOK"}></Radio>
                                </div>
                            </div>
                        </Radio.Group>
                    </div>
                </Drawer>
            </div>
            {showConfirm ? (
                <StyledPopupRedeem>
                    <div className="box-popupconfirm">
                        <div className="img-popupconfirm">
                            <img src="../images/img-gift.svg" alt="" />
                        </div>
                        <div className="title">
                            <div className="text-sub-header">Congrats! This order</div>
                            <div className="text-sub-header">
                                You Get{" "}
                                <span>
                                    <IconPoint size="20" />
                                </span>{" "}
                                {point} Points
                            </div>
                        </div>
                        <div className="btn-popupconfirm">
                            {/* <StyledUsedBtn
                                className="btn-cancel"
                                themeColor={themes?.themeColor!}
                                onClick={() => {
                                    setShowConfirm(false);
                                }}
                            >
                                Cancel
                            </StyledUsedBtn> */}
                            <StyledBtnConfirm
                                themeColor={themes?.themeColor!}
                                className="check-order"
                                onClick={() => {
                                    setShowConfirm(false);
                                }}
                            >
                                Done
                            </StyledBtnConfirm>
                        </div>
                    </div>
                </StyledPopupRedeem>
            ) : null}
            {showPopupConfirm ? (
                <StyledPopupConfirm>
                    <div className="box-popupconfirm">
                        <div className="img-popupconfirm">
                            <img src="../images/ic-alert.png" alt="" />
                        </div>
                        <div className="text-order">{t("page.areyousure")}</div>
                        <div className="text-order">{t("page.onceclaimed")}</div>
                        <div className="btn-popupconfirm">
                            <StyledUsedBtn
                                className="btn-cancel"
                                themeColor={themes?.themeColor!}
                                onClick={() => {
                                    setShowPopupConfirm(false);
                                }}
                            >
                                Cancel
                            </StyledUsedBtn>
                            <StyledBtnConfirm
                                themeColor={themes?.themeColor!}
                                className="check-order"
                                onClick={() => {
                                    setShowPopupConfirm(false);
                                    UIStore.setState({ isLoading: true });
                                    sendOrder(orderId, channel);
                                }}
                            >
                                Confirm
                            </StyledBtnConfirm>
                        </div>
                    </div>
                </StyledPopupConfirm>
            ) : null}
        </StyledContainer>
    );
};
const StyledClaimOrder = styled.div<{ themeColor: string; isExpanded: boolean }>`
    .wrapper-claimorder {
        border-radius: 14px;
        background-color: #fff;
        padding: 14px;
        margin-bottom: 15px;
    }
    .ant-skeleton {
        .ant-skeleton-content {
            .ant-skeleton-title {
                height: 130px;
                border-radius: 16px;
            }
        }
    }
    .title-claim {
        font-size: 16px;
        line-height: 19px;
        color: #000;
        font-weight: 600;
        margin-bottom: 10px;
    }
    .layout-list-claim {
        /* height: ${(props: { isExpanded: boolean }) => (props.isExpanded ? "auto" : "auto")}; */
        max-height: ${(props: { isExpanded: boolean }) => (props.isExpanded ? "auto" : "125px")};
        overflow: hidden;
        height: auto;
        transition: 0.6s;
        .nodata {
            text-align: center;
            font-size: 14px;
            line-height: 17px;
            margin: 20px 0;
            color: #9b9b9b;
            span {
                display: block;
                margin-bottom: 10px;
                img {
                    width: 32px;
                    height: 32px;
                }
            }
        }
    }
    .box-list-claim {
        background-color: #fff;
        padding: 10px 0;
        padding-left: 32px;
        position: relative;
        .img-list-claim {
            position: absolute;
            left: 0px;
            top: 50%;
            transform: translateY(-50%);
            img {
                width: 24px;
                height: 24px;
            }
        }
        .content-list-claim {
            h2 {
                font-size: 12px;
                line-height: 15px;
                font-weight: 600;
                color: #000;
            }
            h3 {
                font-size: 10px;
                line-height: 13px;
                color: #000;
            }
        }

        .btn-list-claim {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
            padding: 6px 13px;
            border-radius: 9px;
            border: 1px solid #e1e1e1;
            font-size: 12px;
            line-height: 15px;
            color: #000;
            span {
                color: #000;
                img {
                    width: 14px;
                    height: 14px;
                }
            }
        }
    }
    .showmore-list-claim {
        text-align: center;
        position: relative;
        &:after {
            display: ${(props: { isExpanded: boolean }) => (props.isExpanded ? "none" : "block")};
            content: "";
            width: 100%;
            height: 50px;
            position: absolute;
            top: -50px;
            left: 0;
            background: rgb(255, 255, 255);
            background: linear-gradient(
                0deg,
                rgba(255, 255, 255, 1) 0%,
                rgba(255, 255, 255, 0) 85%
            );
        }
        .showmore-text-claim {
            cursor: pointer;
            display: inline-block;
            padding: 6px 30px 6px 13px;
            border: 1px solid #e1e1e1;
            border-radius: 9px;
            background-image: url("../images/arrow-showmore.png");
            background-size: 16px;
            background-position: 93% center;
            background-repeat: no-repeat;
        }
    }
`;
const StyledCollect = styled.div<{ themeColor: string }>`
    .wrapper-collect-main {
        position: relative;
        border-radius: 14px;
        padding: 20px 8px 8px 8px;
        min-height: 200px;
        margin-bottom: 10px;
        &:after {
            content: "";
            position: absolute;
            z-index: 0;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            border-radius: 14px;
            background: ${(p) => p.themeColor};
        }
        &:before {
            content: "";
            position: absolute;
            z-index: 1;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-image: url("../images/bg-dot.svg");
            background-position: bottom center;
            border-radius: 14px;
            background-size: contain;
        }
    }
    .ant-skeleton {
        .ant-skeleton-content {
            .ant-skeleton-title {
                height: 222px;
                border-radius: 16px;
            }
        }
    }

    .coin-01 {
        position: absolute;
        top: 0;
        left: 30px;
        z-index: 1;
    }
    .coin-02 {
        position: absolute;
        top: 60px;
        left: 30px;
        z-index: 1;
    }
    .coin-03 {
        position: absolute;
        right: 0;
        top: 10px;
        z-index: 1;
        img {
            width: 50px;
        }
    }
    .wrapper-collect {
        position: relative;
        z-index: 2;
        text-align: center;
        .layout-title-collect {
            display: inline-block;
            margin-bottom: 10px;
            .title-collect {
                border-radius: 20px;
                padding: 8px 10px 8px 50px;
                background-color: #fff;
                display: flex;
                align-items: center;
                position: relative;
                span.icon {
                    position: absolute;
                    width: 40px;
                    height: 40px;
                    left: 0;
                    top: -4px;
                    border: 2px solid #fff;
                    background: ${(p) => p.themeColor};
                    border-radius: 100%;
                    img {
                        width: 50px;
                        height: 50px;
                        position: relative;
                        top: -13px;
                        left: -13px;
                    }
                }
                .highlightTitle {
                    font-size: 17px;
                    line-height: 20px;
                    // color: #c6a12d;
                    font-weight: 600;
                    margin: 0;
                    width: 185px;
                }
                .rows-ic-collect {
                    margin-left: 10px;
                    span.img {
                        display: inline-block;
                        margin-right: 4px;
                        position: relative;
                        top: 2px;
                        img {
                            width: 18px;
                            height: 18px;
                        }
                    }
                }
            }
        }
        .content-collect {
            margin-bottom: 12px;
            h3 {
                font-size: 20px;
                line-height: 23px;
                font-weight: 600;
                color: #fff;
                position: relative;
                display: inline-block;
                .coin-04 {
                    position: absolute;
                    top: -20px;
                    right: -30px;
                    z-index: 1;
                    img {
                        width: 30px;
                    }
                }
            }
            p {
                font-size: 15px;
                line-height: 18px;
                color: #fff;
            }
        }
        .search-collect {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            padding: 10px 16px;
            background-color: #fff;
            border-radius: 14px;
            .group-collect {
                display: grid;
                grid-template-columns: 80px 1fr 50px;
                width: 100%;
                gap: 10px;
                .btn-select-channel {
                    width: 48px;
                    height: 48px;
                    border-radius: 8px;
                    background: linear-gradient(140deg, #ef403b 16.12%, #a01875 107.21%);
                    border: none;
                }
                .main-select-channel {
                    padding: 15px 10px;
                    border-radius: 12px;
                    height: 48px;
                    display: flex;
                    gap: 0;
                    align-items: center;
                    font-size: 14px;
                    color: #525257;
                    line-height: 17px;
                    font-weight: 600;
                    // background-color: #fff;
                    // background-image: url("../images/ic-dd.svg");
                    // background-repeat: no-repeat;
                    // background-position: 95% center;
                    // background-size: 24px;
                    span {
                        width: 29px;
                        height: 29px;
                        overflow: hidden;
                        margin-right: 10px;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
            }
        }
    }
`;

const StyledBtnConfirm = styled.button<{ themeColor: string }>`
    border-radius: 40px;
    background: ${(p) => p.themeColor};
    font-size: 13px;
    color: #fff;
    padding: 14px 32px;
    height: auto;
    width: 100%;
    border: none;
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;
const StyledPopupConfirm = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 45px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .text-order {
            font-size: 18px;
            line-height: 21px;
            font-weight: 600 !important;
            color: #000;
            text-align: center;
            margin-bottom: 20px;
        }
        .img-popupconfirm {
            position: absolute;
            top: -40px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: #336c51;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        flex-direction: column;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
            display: block;
        }
    }
`;
const StyledPopupRedeem = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 45px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .text-order {
            font-size: 12px;
            line-height: 15px;
            color: #525257;
            margin-bottom: 5px;
            text-align: center;
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: #336c51;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        flex-direction: column;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
            display: block;
        }
    }
`;

const StyledContainer = styled.div<{ color: string }>`
    /* background-color: ${(p) => p.color}; */
    background-color: #f9f9f9;
    overflow: scroll;
    .container {
        padding: 32px 16px;
        position: relative;
        .banner-step-claim {
            border-radius: 14px;
            margin-bottom: 15px;
            .ant-skeleton {
                .ant-skeleton-content {
                    .ant-skeleton-title {
                        height: 400px;
                        border-radius: 16px;
                    }
                }
            }
            img {
                width: 100%;
                border-radius: 14px;
            }
        }
        .backIcon {
            display: flex;
            cursor: pointer;
            z-index: 1;
            align-items: center;
            justify-content: space-between;
            width: calc(100% - 32px);
            position: absolute;
            left: 16px;
            top: 32px;
        }
        .header {
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            line-height: 19px;
            text-align: center;
            margin-bottom: 20px;
            .ant-skeleton {
                width: 100%;
                .ant-skeleton-content {
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    .ant-skeleton-title {
                        height: 100px;
                        width: 100px;
                        border-radius: 16px;
                    }
                }
            }
            img {
                width: 100px;
                height: auto;
                border-radius: 8px;
            }
        }
        .title-big-step {
            text-align: center;
            margin-bottom: 30px;
            .title-color {
                background: ${(p) => p.color};
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-size: 64px;
                line-height: 80px;
                font-weight: 600;
                margin-bottom: 5px;
                display: block;
            }
            .sub-title-color {
                font-size: 32px;
                line-height: 37px;
                font-weight: 600;
                color: #000;
                position: relative;
                display: inline-block;
                &:after {
                    content: "";
                    width: 30px;
                    height: 21px;
                    background-image: url("../images/ic-star-title.svg");
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    position: absolute;
                    top: -15px;
                    right: -20px;
                }
            }
        }
        .content-select-channel {
            background-color: #fff;
            border-radius: 18px;
            padding: 20px 28px;
            .box-select-channel {
                padding: 14px;
                background-color: #f3f4f9;
                border-radius: 14px;
                .title-box-select {
                    font-size: 14px;
                    text-align: center;
                    color: #000;
                    margin-bottom: 12px;
                    font-weight: 600;
                }
                .main-select-channel {
                    padding: 15px 20px;
                    border-radius: 12px;
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    border: 1px solid ${(p) => p.color};
                    margin-bottom: 15px;
                    font-size: 14px;
                    color: #525257;
                    line-height: 17px;
                    font-weight: 600;
                    background-color: #fff;
                    background-image: url("../images/ic-dd.svg");
                    background-repeat: no-repeat;
                    background-position: 95% center;
                    background-size: 24px;
                    span {
                        width: 25px;
                        height: 25px;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
                .input-select-channel {
                    margin-bottom: 15px;
                }
                .btn-select-channel {
                    button {
                        border-radius: 14px;
                        background: ${(p) => p.color};
                        font-size: 13px;
                        color: #fff;
                        padding: 14px 32px;
                        height: auto;
                        width: 100%;
                    }
                }
            }
            .box-liststep {
                padding: 0px 0px 15px 60px;
                position: relative;
                .img-box-liststep {
                    position: absolute;
                    left: 0;
                    top: 3px;
                    // background-image: url("../images/img-bg-liststep.svg");
                    // background-size: contain;
                    // background-repeat: no-repeat;
                    // background-position: center;
                    // width: 42px;
                    // height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    span {
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                        color: #fff;
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
                .text-box-liststep {
                    font-size: 20px;
                    line-height: 24px;
                    color: rgb(0, 0, 0);
                    font-weight: 600;
                    min-height: 48px;
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #ff0000 !important;
        font-weight: 500;
    }
    .ant-tabs-nav-wrap {
        .ant-tabs-ink-bar {
            position: absolute;
            background: ${(p) => p.color};
            pointer-events: none;
            width: 20px !important;
            height: 3px;
            bottom: 0px;
            left: 37px;
            border-radius: 4px;
        }
    }
    .ant-tabs-content {
        margin-top: 10px;
    }
`;
